import type FamilyModel from 'frontend/models/family';

export default function (families: FamilyModel[]) {
  return families.filter((family: FamilyModel) => !family.parent.content);
}
